import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';

function DonutChart({ data }) {
    const [chartData, setChartData] = useState({ labels: [], datasets: [{ data: [] }] });
    const options = {
        cutoutPercentage: 60,
        legend: {
            display: false,
        },
        tooltips: { bodyFontSize: 20 },
        responsive: false,
        maintainAspectRatio: false,
    };

    useEffect(() => {
        if (data) {
            let labels = data.map((element) => element.name);
            let values = data.map((element) => element.count);
            setChartData({
                labels: labels,
                datasets: [
                    {
                        data: values,
                        backgroundColor: [
                            '#137eff',
                            '#8b5edd',
                            '#5ac146',
                            '#eceff1',
                            '#fa5838',
                            '#ffbc34',
                            '#6c757d',
                            '#343a40',
                            '#39cccc',
                            '#01ff70',
                            '#85144b',
                            '#F012be',
                            '#3d9970',
                            '#111111',
                            '#aaaaaa',
                        ],
                    },
                ],
            });
        }
    }, [data]);
    return <Doughnut data={chartData} options={options} />;
}

export default DonutChart;
